<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    Installation Report
                  </v-toolbar-title>
                </div>
                <!-- <div class="ml-auto">
                  <v-btn color="primary" @click="goBack()">
                    <v-icon class="mr-2">mdi-arrow-left</v-icon> Back
                  </v-btn>
                </div> -->
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            :single-expand="table.singleExpand"
            :expanded.sync="table.expanded"
            show-expand
            item-key="area"
            :search="search"
            :item-class= "row_classes"   
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template v-slot:expanded-item="{ headers, item }">
              <td class="p-0" :colspan="headers.length">
                <v-data-table
                  :headers="headers"
                  :items="item.areas"
                  :loading="table.loading"
                  :single-expand="table.singleExpand"
                  :expanded.sync="table.expanded"
                  show-expand
                  item-key="area"
                  hide-default-footer
                  loading-text="Loading... Please wait"
                  class="sub-areas"
                >
                  <template v-slot:[`item.data-table-expand`]> </template>
                </v-data-table>
              </td>
            </template>

            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>

            <template v-slot:[`item.isPaid`]="{ item }">
              {{ item.isPaid ? "Yes" : "No" }}
            </template>

            <template v-slot:[`item.amountPaid`]="{ item }">
              {{ item.amountPaid ? item.amountPaid.toLocaleString() : 0 }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import moment from "moment";
export default {
  data() {
    return {
      search: "",
      paths: {
        viewInfo: "/draw/view",
      },
      table: {
        expanded: [],
        singleExpand: false,
        sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Area",
            sortable: false,
            value: "area",
            width: "25%",
          },
          { text: "Total User", align: "center", value: "totalUser" },
          { text: "Active User", align: "center", value: "activeUser" },
          { text: "Inactive User", align: "center", value: "inactiveUser" },
          { text: "Active %", align: "center", value: "active" },
          { text: "Today's Revenue", align: "center", value: "todayRevenue" },
          { text: "Dormant User", align: "center", value: "dormant" },
          { text: "", value: "data-table-expand" },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async getList() {
      this.table.loading = true;
      await this.$api
        .get("/acquisition/report?report=subscriberInstallationGroup")
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    viewDrawDetail(data) {
      this.$store.dispatch("addDrawDetails", data);
      this.$router
        .push({ path: `${this.$route.matched[0].path}/draw/view/${data.id}` })
        .catch(() => {});
    },

    row_classes() {
      return "row_classes"
    }
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
